import React, { Component } from 'react';
import './Button.module.scss';
import {history} from 'components/App/components/UnauthenticatedApp';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faRocket, faGamepad, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';


class Button extends Component {

    render() {
        var { text, icon, style } = this.props
        return (
            <div styleName='transparent-button-wrapper'>
                <a styleName='transparent-button' href='https://www.studiotast.com/goto' target='blank' style={style} styleName='button'>
                    {icon}    {text}
                </a>
            </div>
        );  
    }
}

export default Button;


// WEBPACK FOOTER //
// ./resources/assets/components/UI/ButtonTast/ButtonTransparentWhite/ButtonTransparentWhite.jsx